import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { ArticleHeading3, TDeviceType, UIText2, ArticleHeading4 } from '@cian/ui-kit';
import { IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import { clsx } from 'clsx';

import * as styles from './MortgagePrograms.css';
import { IMortgagePrograms } from '../../types/promosPage/mortgagePrograms';
import { Section } from '../Section';

interface IMortgageProgramsProps {
  deviceType: TDeviceType;
  mortgagePrograms: IMortgagePrograms[];
  onMortgageProgramsListShow: () => void;
  onMortgageProgramClick: () => void;
}

export const MortgagePrograms: React.FC<IMortgageProgramsProps> = ({
  deviceType,
  mortgagePrograms,
  onMortgageProgramsListShow,
  onMortgageProgramClick,
}) => {
  const isMobile = deviceType === 'tablet' || deviceType === 'phone';
  // istanbul ignore next
  const InfoTitle = isMobile ? ArticleHeading4 : ArticleHeading3;

  return (
    <Section title="Ипотечные программы" data-testid="MortgageProgramsSection">
      <ActionAfterViewObserver triggerOnce callback={onMortgageProgramsListShow} wrapper={false}>
        <div className={clsx(styles['list'], styles[`list-${deviceType}`])}>
          {mortgagePrograms.map(({ title, description, url, iconUrl }) => {
            return (
              <a
                className={clsx(styles['item'], styles[`item-${deviceType}`])}
                href={url}
                key={title}
                target="_blank"
                rel="noopener noreferrer"
                onClick={onMortgageProgramClick}
              >
                <div className={clsx(styles['logo-container'], styles[`logo-container-${deviceType}`])}>
                  <img className={styles['logo']} src={iconUrl} alt="" />
                </div>
                <div className={styles['content']}>
                  <div className={styles['info']}>
                    <InfoTitle as="h3" color="decorative-theme-dark">
                      {title}
                    </InfoTitle>
                    <UIText2 color="current_color">{description}</UIText2>
                  </div>
                  <IconActionChevronRight16 />
                </div>
              </a>
            );
          })}
        </div>
      </ActionAfterViewObserver>
    </Section>
  );
};
